"use strict";

/**
* @ngdoc service
* @name nms.components.autoUpdater:DevicePollingRESTService
* @description
* # DevicePollingRESTService - Serviço REST para serviços de polling.
* Factory in the nms.
*/
var app = angular.module("nms");

app.factory("DevicePollingRESTService", ["Restangular",
    function(Restangular) {
        const basePath = "/device-management-web";

        return {
            verifyPollingIsRunning(resourceId: number) {
                return Restangular.one(`${basePath}/pollingUnderway/${resourceId}`).customGET();
            },
            requestPolling(resourceId, client) {
                return Restangular.one(`${basePath}/requestPolling?resourceId=${resourceId}&client=${client}`).customPOST();
            },
            requestPollings(pollingRequests, client) {
                return Restangular.one(`${basePath}/requestPollings?client=${client}`).customPOST(pollingRequests);
            },
            getFirstPollingStatus(resourceId: number) {
                return Restangular.one(`${basePath}/firstPollingStatus/${resourceId}`).customGET();
            },
            getDevicesPollingUnderway() {
                return Restangular.one(`${basePath}/devicesPollingUnderway`).customGET();
            },
            getPollingTimeoutInMinutes() {
                return Restangular.one(`${basePath}/pollingResponseTimeout`).customGET();
            }
        };
    }
]);
